export default __webpack_public_path__ + "static/media/hockeyrink3.e2a04080.jpg";